import { useCallback } from 'react';
import { useNoteDeleteMutation } from 'api';
import { useNotificationMessages } from 'hooks/useNotificationMessages';

export const useDeleteModal = (onDeleteModalClose: () => void) => {
  const { handleError, handleSuccess } = useNotificationMessages();

  const [noteDelete, { isLoading: noteDeleteIsLoading }] = useNoteDeleteMutation();

  const onCancel = useCallback(() => {
    onDeleteModalClose();
  }, [onDeleteModalClose]);

  const onRemoveConfirm = useCallback(
    async (noteId: string | undefined) => {
      if (noteId) {
        try {
          const response = await noteDelete({
            noteId,
          });
          if (response?.data?.success) {
            handleSuccess('Note was successfully deleted');
            onCancel();
          } else {
            handleError(response.error);
          }
        } catch (err) {
          handleError(err);
        }
      }
    },
    [onCancel, handleError, handleSuccess, noteDelete]
  );

  return {
    onRemoveConfirm,
    isLoading: noteDeleteIsLoading,
    onCancel,
  };
};
